<div class="container">
  <div class="header">
    <div class="action-hub">
      <div class="back-button-container">
        <button
          class="back-button"
          id="backButton"
          (click)="back()"
          [attr.aria-label]="'application.global.buttons.back' | translate"
        >
          <ml-icon [iconName]="'arrow-left'"></ml-icon>
          {{ 'application.global.buttons.back-records' | translate }}
        </button>
      </div>
      @if (clientName()) {
        <div class="client-name-container">
          <p
            class="action-hub-text"
            [innerHTML]="'application.records.action-hub.numauto' | translate: { numAuto: id() }"
          ></p>
          <p
            class="action-hub-text"
            [innerHTML]="'application.records.action-hub.client' | translate: { clientName: clientName() }"
          ></p>
        </div>
      } @else {
        <ml-custom-line-skeleton class="skeleton" [customHeight]="2.4"></ml-custom-line-skeleton>
      }
    </div>
    @if (!tabLoader()) {
      <ml-navbar
        [tabList]="navbarTabList"
        [translationKey]="'application.records.action-list.'"
        [disabledTabKeyList]="disabledNavbarTabKeyList()"
        [defaultSelectedTab]="getActualPathKeyValueLabel()"
        [count]="notificationsCount()"
        [noticationsTab]="'MESSAGING'"
        (tabClicked)="changeAction($event)"
      ></ml-navbar>
    } @else {
      <ml-navbar
        [tabList]="navbarTabList"
        [translationKey]="'application.records.action-list.'"
        [disabledTabKeyList]="[]"
        [defaultSelectedTab]="getActualPathKeyValueLabel()"
        [noticationsTab]="'MESSAGING'"
        [loadingStatus]="true"
        (tabClicked)="changeAction($event)"
      ></ml-navbar>
    }
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
